'use strict';
var localisations = require('../account.localisations');

export default class SettingsController {
  user = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;


  /*@ngInject*/
  constructor(Auth, common, $scope) {
    this.Auth = Auth;
    this.$scope = $scope;
    this.common = common;
    this.common.setBack(null, null);
    this.localisations = localisations[this.common.getLocale()];
    this.currentUser = {};
    Auth.getCurrentUser()
    .then(user => {
      this.currentUser = user;
    });

    this.profileUpdating = false;
    this.errors = {};
    this.newFileUpload = '';
    this.imageSaving = false;

    var that = this;

    // SET UP LISTENER FOR FILE UPLOAD - ANGULAR BINDINGS NOT READY IN FILEUPLAOD
    if(window.File && window.FileReader && window.FileList && window.Blob) {
      document.getElementById('profileimg').addEventListener('change', function() {
        that.uploadNewImage();
      }, false);
    } else {
      that.common.setAlert('File Upload Error', 'danger', 'The File APIs are not fully supported in this browser. Please get with the programme and use a modern browser! :) ', false, true);
    }
  }

  updateProfile(form) {
    var that = this;
    this.submitted = true;
    if(form.$valid && !this.profileUpdating) {
      this.profileUpdating = true;
      this.Auth.updateProfile(this.currentUser.name, this.currentUser.email, this.currentUser.title, this.currentUser.opinionProfile, this.currentUser.anonymous, function() {
        // Do nothing;
        that.profileUpdating = false;
      }, function() {
        that.common.setAlert('Save Error', 'danger', 'Looks like there is a problem saving your profile. Please check the details and try again.', false, true);
        that.profileUpdating = false;
      });
    }
  }

  changePassword(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.changePassword(this.user.oldPassword, this.user.newPassword)
        .then(() => {
          this.message = 'Password successfully changed.';
        })
        .catch(() => {
          form.password.$setValidity('mongoose', false);
          this.errors.other = 'Incorrect password';
          this.message = '';
        });
    }
  }

  uploadNewImage() {
    var that = this;
    var file = document.getElementById('profileimg').files[0];
    if(file) {
      that.common.setLoading(true);
      var reader = new FileReader();

      reader.onload = function(readerEvt) {
        var binaryString = readerEvt.target.result;
        var savedImage = that.currentUser.profileimage;
        that.currentUser.profileimage = btoa(binaryString);
        that.$scope.$apply();

        // upload to DB
        that.Auth.updateImage(that.currentUser.profileimage, function() {
          // ADD Alerts for success
          that.common.setLoading(false);
        }, function() {
          // ADD Alert for failure
          that.currentUser.profileimage = savedImage;
          that.common.setAlert('Save Error', 'danger', 'Looks like the image did not upload and save. Please try again.', false, true);
          that.common.setLoading(false);
        });
      };
      reader.readAsBinaryString(file);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/settings/settings.controller.js